let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hstt4")).then(() => parcelRequire('9K8DU'));